import { Personality } from "@/types/personality";

export const personalities: Personality[] = [
  {
    type: "ESTJ",
    id: "great_manager",
    name: "名監督",
    description:
      "あなたは深い思考から法則やルールを生む「厳しい監督型」です。社交的なので、チームとして取り組んだ場合もメンバーの力を100％引き出します。責任感も強く、論理的であることを好むため、仕事の生産性を上げるルール作りまでも対応できる資質があります。",
    strongPoint:
      "組織の統制に関心が強く、ロジックベースの明確なルールを作れるので、人間関係に囚われない正しい判断を下すことができます。集団を管理する能力であなたに勝るものはいません。意志が強いため、限られた予算や期間で、必ずやりきる力があります。",
    weakPoint:
      "ルールに厳しいあなたは、保守的で変化に弱い面もあります。信念に基づいて、自らに対しても高い基準を設けています。このため、自分を追い込みすぎてしまうことがあります。余裕がなくなると、ストレートな物言いで相手の気分を害したり、細部が気になりすぎて小うるさく高圧的になったりするため、注意が必要です。",
    tactic:
      "中級の「大事にする」講座はいかがでしょうか？自分の余裕の持ち方や、相手に耳を傾ける具体的な行動のコツが身につきます。",
    tacticThumbnail: "book-take-care-of.png",
    tacticId: "a90636ab-eec7-41ff-ac65-f68566c72d4d",
  },
  {
    type: "ISTJ",
    id: "model",
    name: "コツコツ模範",
    description:
      "あなたは縁の下で会社を支える「コツコツ模範型」です。しっかりとしたロジックとメソッドを用いて仕事をすることが好き。派手な仕事ではありませんが、コツコツ積み上げ常に成果を出します。集中力と粘り強さがあり、チームを適切にマネジメントすることができます。",
    strongPoint:
      "現実的で合理的な考え方を好む一方で、自分だけの強いこだわりをもつことも特徴です。コツコツと努力を重ねるのが好きで、同じやり方を何度も正確にこなせる真面目さも持ち合わせます。分析力や思考力も高いため率いたチームは成果を出します。",
    weakPoint:
      "規律を重んじているあなたは、型にはまらない状況にはストレスを感じます。経験したことがないことを受け入れるのが苦手であるため、古いやり方に固執して損をしたり、融通の利かない人というレッテルを貼られてしまったりすることも。",
    tactic:
      "上級の「イノベーション」講座はいかがでしょうか？意見交換からアイデア、そしてイノベーションを生む過程を学ぶことで、新しい考え方を構造的に捉えることができるようになります。",
    tacticThumbnail: "book-innovation.png",
    tacticId: "01666933-da59-493f-91be-a5b8c1ba8e16",
  },
  {
    type: "ESTP",
    id: "ultimate_realist",
    name: "究極リアリスト",
    description:
      "あなたは、状況に応じて実行力を発揮することができる「究極リアリスト型」です。1番の強みである実行力を遺憾なく発揮して期待どおりの成果を出すことができます。周囲との調和を大事にするタイプかつ誠実で責任感もあるため、率いたチームにも結束力が生まれます。",
    strongPoint:
      "プロジェクトを成功に導くことができる高い実行力があります。また、物事の本質を見抜く力が高い点も強みです。結果としてメンバーに対して自分なりの意見やビジョンを伝えるのがうまく、全体を見通しながら成果に向けてプロジェクトを統括することに長けています。",
    weakPoint:
      "自分なりの方法を駆使した進め方に対してこだわりが強すぎる傾向があります。一度決めたやり方や出した答えに対し、人からのアドバイスを反映させることが苦手で、批判や対立も敏感です。自分の意見に囚われるあまり判断力や実行力が鈍ってしまうことがあるため注意しましょう。",
    tactic:
      "中級の「大事にする」講座はいかがでしょうか？自分の余裕の持ち方や、相手に耳を傾ける具体的な行動のコツが身につきます。",
    tacticThumbnail: "book-take-care-of.png",
    tacticId: "a90636ab-eec7-41ff-ac65-f68566c72d4d",
  },
  {
    type: "ISTP",
    id: "workman",
    name: "必殺仕事人",
    description:
      "あなたは現実主義で一匹狼、頭の切れる「必殺仕事人型」です。分析力や論理的思考力が高く頭も柔らかいので、迅速なトラブルシューティングには定評があります。一人の世界に没頭して細部にこだわることができるため、専門的な技能への適性は全てのタイプの中で最も高いです。",
    strongPoint:
      "物事の仕組みを理解することに強い関心をもつほか、興味分野に対しての深い掘り下げを行う能力に長けています。五感で学び、実践を通じて成長するタイプで、1つの技術をとても高いレベルまで昇華させることができます。人の話を深く聞き、適切なアドバイスを行うこともできます。",
    weakPoint:
      "義務や責任よりも個人的な興味を優先してしまうことが多く、気まぐれなところがあります。また人に干渉されることや過剰なルールに縛られた組織での立ち振る舞いも苦手です。個人主義的な側面が強く、コミュニケーション不足で孤立してしまう恐れがあります。",
    tactic:
      "中級の「大事にする」講座はいかがでしょうか？相手に耳を傾ける重要性を確認し、具体的な行動のコツを身につけることができます。",
    tacticThumbnail: "book-take-care-of.png",
    tacticId: "a90636ab-eec7-41ff-ac65-f68566c72d4d",
  },
  {
    type: "ESFJ",
    id: "innovation",
    name: "イノベーション",
    description:
      "あなたは社交的でエネルギッシュに行動できる「イノベーション型」です。高いコミュニケーション能力を武器にどんな場面でも活躍します。チームメンバーだけでなく他社との交流も好きで、人と人のつながりを大切にするため、イノベーションを生み地域を活性化する可能性を有しています。",
    strongPoint:
      "何事にも適応できる能力があります。コミュニケーションやプレゼンテーションが得意でどんな人も巻き込んでいく力があるため、多くの人から信頼されていることでしょう。自分に自信があり、思い立ったらすぐ行動するタイプなので、スピード感をもって実行することができます。",
    weakPoint:
      "遊び心のない仕事には興味がなく、サボってしまうことがあります。また、やらなければいけないことであっても「気持ちがノらない」と後回しにしたり、詰めが甘くなってしまったりしがちです。対人関係にストレスがたまると、自分の評価に敏感になりすぎることがあるため注意が必要です。",
    tactic:
      "上級の「イノベーション」講座はいかがでしょうか？長所のコミュニケーション能力を活かし、多くの人を巻き込んでアイデアを形にするスキルを身につけることができます。",
    tacticThumbnail: "book-innovation.png",
    tacticId: "01666933-da59-493f-91be-a5b8c1ba8e16",
  },
  {
    type: "ISFJ",
    id: "partner",
    name: "頼れる相棒",
    description:
      "あなたは他の人ではできない努力をコツコツと積み上げることが得意な「頼れる相棒型」です。気遣いができ、細部にも気を配れるため、完成度の高いアウトプットを出します。チーム全体が高い成果を出せるようにサポートするので中長期的なパフォーマンスが高くなります。",
    strongPoint:
      "あなたは粘り強く最後まで諦めず仕事に取り組むことができ、その粘り強さから確実な成果を出すことができます。人からアイデアを提示された場合には、受け入れることができる柔軟性も持ち合わせています。普通なら見逃してしまう些細なミスに気づくことができることも強みです。",
    weakPoint:
      "新しいことへの心理的抵抗が強く、過去にとらわれてしまうことが往々にしてあります。クリエイティブな仕事に苦手意識を持っている可能性が高いです。人間関係では仲間から頼られすぎてしまうことがあるので、仕事を抱えて疲れ果ててしまわないように注意が必要です。",
    tactic:
      "上級の「新規事業の教科書」講座はいかがでしょうか？中長期的な戦略の立て方を知ることで、実直に仕事に取り組める強みをより活かしていくことができます。",
    tacticThumbnail: "book-new-business.png",
    tacticId: "3c3732a9-3cef-464d-851c-85d57c5d3f62",
  },
  {
    type: "ESFP",
    id: "entertainer",
    name: "エンターテイナー",
    description:
      "あなたは、直感を重視し、非常にアクティブな「エンターテイナー型」です。行き当たりばったりに見られますが、本人的にもそれを自覚しています。しかしコミュニケーション能力と持ち前の機転で難題も要領よく解決していくため、実はとてもクレバーです。",
    strongPoint:
      "コミュニケーション能力、分析力、発想力、行動力が高くハイスペックなあなた。お調子者だと見られることも多いですが、常識的で実務能力も高いのが特徴です。人の気持ちを捉えるのが得意なので、どんな人でも「やる気にさせる力」があります。",
    weakPoint:
      "複雑な問題を解決することなどを得意とせず、ストレスを感じるタイプです。落ち着くことや刺激がないことに耐性がなく、長期計画もあまり得意ではありません。コミュニケーションの達人ですが、調子に乗り過ぎて信頼を失わないように注意してください。",
    tactic:
      "上級の「新規事業の教科書」講座はいかがでしょうか？苦手意識のある計画の立て方を知ることで、自分で中長期の戦略を描いたり、あるいは部下にその仕事を任せたりすることができます。",
    tacticThumbnail: "book-new-business.png",
    tacticId: "3c3732a9-3cef-464d-851c-85d57c5d3f62",
  },
  {
    type: "ISFP",
    id: "artist",
    name: "アーティスト",
    description:
      "あなたは創造力と類まれなセンスに恵まれた「アーティスト型」です。何かに没頭することができるため仕事を生きがいとして捉えることができます。高い感受性と芸術的なセンスを生かしたクリエイティブな仕事で右に出るものはいません。",
    strongPoint:
      "独創的な発想から商品を生み出すことができます。共感性が高く、控えめながら明るい性格なのでメンバーと足並みを揃えながら役割を全うします。平和主義者で忍耐力もあるので、自分よりも相手を優先する一面もあります。",
    weakPoint:
      "複雑なことを考えたり、効率的に仕事をこなすことには関心がありません。締め切りも遅れがちなところがあります。相性の悪い人と一緒に働くと、情緒不安定になりやすく、パフォーマンスが一気に低下することがあるため注意が必要です。",
    tactic:
      "初級の「自己管理能力を鍛える」講座はいかがでしょうか？自分をマネジメントする方法を身につけることで、より高いレベルのパフォーマンスを発揮できるようになります。",
    tacticThumbnail: "book-self-management.png",
    tacticId: "629f4773-1b05-426e-a492-7aae4bdad84d",
  },
  {
    type: "ENTJ",
    id: "lone_leader",
    name: "孤高のリーダー",
    description:
      "野心家で先見の明をもつ「孤高のリーダー型」です。状況を常に改善し、上を目指すため、踏み出す力とやりきる力を兼ね備えています。深い思考から考え出したアイデアを、組織をまとめるカリスマ性で次々と実現させるでしょう。",
    strongPoint:
      "明確なビジョンを示し、目標に向かってチームを導くことができます。周囲の反対意見に屈することのない性格なので、組織改革にも適性があります。改革者であり、かつリスク管理能力も高いため、安定して成果を出すことができます。",
    weakPoint:
      "思考力と実行力に長けたあなたは、相談事を聞いたときに具体的な解決策を考えてしまう傾向があります。相談者の気持ちを考えて共感してあげるということが苦手です。また目的の達成に夢中になるとき、部下や従業員に厳しいノルマを課し、成果だけを求めてしまうことがあるため注意する必要があります。",
    tactic:
      "上級の「経営者のリーダーシップ」講座はいかがでしょうか？個人の目標と会社の目標を一体で考えることで、目標に向かう組織を構築することができます。",
    tacticThumbnail: "book-leadership.png",
    tacticId: "3c4b0002-a4f1-4092-a066-2a9a8b40a156",
  },
  {
    type: "INTJ",
    id: "strategist",
    name: "戦略参謀",
    description:
      "あなたは溢れるアイデアと高い戦略性で結果を出す「戦略参謀型」です。高い能力で前例のない施策でも果敢にチャレンジして次々と実現させます。複雑な問題でも仕組みを見抜き、さらにアイデアを加えることができるため、常に二手先・三手先のことを考えられる能力があります。",
    strongPoint:
      "高い戦略性や計画性によって組織を引っ張って行くことができます。論理的かつ多面的な考え方ができるため、皆が納得する戦略を描き出すことができます。実行力もずば抜けて高く、適材適所の人員を配置し、自ら立てたスケジュール通りに完了させます。",
    weakPoint:
      "完璧主義者であり、業務に対する責任感が強いことに加えて、部下にも完璧な仕事を求める傾向があります。社交性が低く、自分の意見に固執する一面もあるため、一緒に働きづらいという評価を受けることもあります。各人に得意不得意や良さがあることを認めることでチームワークがよくなる可能性が高いです。",
    tactic:
      "中級の「大事にする」講座はいかがでしょうか？相手との関係性を見直すコツを具体的に知ることができます。",
    tacticThumbnail: "book-take-care-of.png",
    tacticId: "a90636ab-eec7-41ff-ac65-f68566c72d4d",
  },
  {
    type: "ENTP",
    id: "entrepreneur",
    name: "起業家",
    description:
      "あなたは型にはまらない発想で既成概念を打ち破る「起業家型」です。優れた直感で素晴らしいアイデアを思いつき、それを実現させることに熱中するタイプ。斬新なことばかりやりたがるので、失敗することも多いですが挑戦し続けることでホームランを打つことができるでしょう。",
    strongPoint:
      "頭の回転が速く、論理的な決断により部下を引っ張っていくことができます。刺激的な挑戦ができる仕事が得意なため、革新的なアイデアを取り入れたり、組織を改革したりすることに長けています。自由な環境であれば、持ち前の想像力と好奇心を生かして大きな成果を出すことができます。",
    weakPoint:
      "集中力が続かず、ルーチンワークを正確にこなすのが苦手なため、不真面目で信頼できない人だと思われてしまう可能性があります。興味がころころと移り変わるため、小さなミスやうっかり忘れが多くなります。細かい計画や、好奇心が向かない仕事ではパフォーマンスを発揮することができません。",
    tactic:
      "初級の「自己管理能力を鍛える」はいかがでしょうか？持ち前の好奇心に管理能力を加えることで、コンスタントに挑戦する力を身につけることができます。",
    tacticThumbnail: "book-self-management.png",
    tacticId: "629f4773-1b05-426e-a492-7aae4bdad84d",
  },
  {
    type: "INTP",
    id: "detective",
    name: "天才探偵",
    description:
      "あなたは創造力が豊かで天才肌の「天才探偵型」です。複雑な問題を解決し、難しい目標を達成することに意欲的な性格で、その知性とクリエイティビティを発揮できたときには大きな成果を上げることができます。先入観のない思考力はユニークなアイデアを次々と生み出します。",
    strongPoint:
      "柔軟な思考を持ち、論理的な提案にはすぐさま理解を示します。複雑な問題でも解決する知性を持つため、技術革新やサービス開発で力を発揮できます。少人数で気心の知れた仲間に囲まれているとリラックスできるため、チームメンバー選びに慎重になるとよいでしょう。",
    weakPoint:
      "恥ずかしがり屋で、新しい人とのコミュニケーションに消極的です。また知的であることを重視しすぎるあまり、なにか矛盾に気づくと相手の感情を気にせず指摘する傾向があります。その結果、「あの人は私たちと違うから」と距離を置かれてしまう可能性があるため注意が必要です。",
    tactic:
      "中級の「チームマネジメント」講座はいかがでしょうか？自分が所属する組織のタイプを認識することで、より自分の得意分野に集中することができるでしょう。",
    tacticThumbnail: "book-team-management.png",
    tacticId: "5f94cf5c-3518-4101-9b8b-55a294b635e3",
  },
  {
    type: "ENFJ",
    id: "balancer",
    name: "バランサー",
    description:
      "あなたは人を巻き込み成果を出す「バランサー型」です。計画よりも実行を担当することに長けています。信頼感とカリスマ性を兼ね備えたリーダーシップを持っているため、あなたが率いたチームは高い生産性を発揮し、目標を達成します。",
    strongPoint:
      "思いやりがあり、非常に寛容です。自分よりも他人の利益を優先することができるため、部下に慕われます。共感性が高く、部下のモチベーションに敏感で、彼らの成長を促すことが得意なあなたは、リーダーとしての役割を全うすることができるでしょう。",
    weakPoint:
      "理想主義で融通が利かない一面があります。また余裕がなくなると感情的な判断になりやすくなるため、緊張感で張り詰めるような業務は不向きともいえます。共感性が高いという長所ゆえに、周囲の意見を取り入れすぎて、自身の軸がぶれることがあるため、気をつけましょう。",
    tactic:
      "初級の「説得力のある話し方」講座はいかがでしょうか？長所である協調性を活かしながら、さらにコミュニケーション能力を引き上げるための具体的な行動がわかります。",
    tacticThumbnail: "book-persuasive-power.png",
    tacticId: "f8be18e5-6e35-4d54-90aa-f8537e53fb1a",
  },
  {
    type: "INFJ",
    id: "high_concept",
    name: "ハイコンセプト",
    description:
      "あなたは独創的な世界観をもつ「ハイコンセプト型」です。独創的な世界観と、それを表現できる感性やデザイン性の高さを持っており、レベルの高いアウトプットを出すことができます。自分の価値観を曲げない性格なため、自分の裁量で自由に仕事ができる環境がおすすめです。",
    strongPoint:
      "想像力があり、未来に対する明確なビジョンを持って行動できるあなたは、個人の興味を追求することで大きな成果を出すことができます。個人主義の一方で、共感性が高く、思いやりがあり、皆を平等に扱うあなたはリーダーとしても優秀です。部下を細かく管理せず、ある程度自由に仕事をさせるタイプなので風通しのいい職場を作れます。",
    weakPoint:
      "自分の理想に固執し過ぎるため、他人から理解されないことがあります。それに対して考えすぎてしまったり、ストレスを抱え込んだりしてしまうことがあるでしょう。人一倍繊細であるため、リラックスできていないと感じたらできるだけ早く休みましょう。",
    tactic:
      "初級の「ロジカルシンキング」はいかがでしょうか？あなたの感覚的に優れた思考に論理を持ち込むことができれば、鬼に金棒です。",
    tacticThumbnail: "book-logical.png",
    tacticId: "ee4ae1b5-0bec-453a-950c-acafb98a87ef",
  },
  {
    type: "ENFP",
    id: "protagonist",
    name: "マンガ主人公",
    description:
      "あなたは、常に事業の継続的な発展について考える「マンガ主人公型」です。鋭い観察眼と持ち前の行動力で高い成果を上げることができます。また予測不能なトラブルが起こり、周りが混乱しているなかでも、トラブル上等という気持ちで嬉々として仕事することができます。",
    strongPoint:
      "洞察能力の高さと決断スピードに秀でています。多才で問題解決能力も高く、チャンスを逃さない勘さえも持ち合わせています。また前向きで明るい性格のあなたは、コミュニケーション能力が高く、他人への影響力も大きいです。人を引き込む能力が高く、人気があるリーダーとなることでしょう。",
    weakPoint:
      "予想外の出来事やスリルを楽しむ性格であり、刺激を求めすぎるきらいがあります。トラブル対応が得意なため大きな問題にはなりませんが一緒に仕事する人にとってはストレスになることも。また何でも自分で対応してしまうので、部下が育ちづらいです。ときには部下を叱責する厳しさや、部下に任せて辛抱強く待つことも必要です。",
    tactic:
      "中級の「チームマネジメント」講座はいかがでしょうか？チームにルールを持ち込む方法を学び、部下を育てられるようにしましょう。",
    tacticThumbnail: "book-team-management.png",
    tacticId: "5f94cf5c-3518-4101-9b8b-55a294b635e3",
  },
  {
    type: "INFP",
    id: "person",
    name: "人格者",
    description:
      "あなたは思慮深く洞察力に優れた「人格者型」です。組織やコミュニティに忠実であり、高いコミュニケーション能力もあるので、周りの人からいつも頼りにされます。事業をぐいぐい推進するというよりも、会社の方針転換など社内の意思統一をするような場面で、右に出るものはいない活躍をするでしょう。",
    strongPoint:
      "プロジェクトの進捗管理やメンバーとのコミュニケーションが得意で、チーム全体を円滑に動かす能力が非常に高いです。面倒見がよくフレンドリーで、同じチームの人からの人望があついあなたは、ルールや役割を調整する仕事にも適性を発揮するでしょう。部下の意見にしっかりと耳を傾ける点も慕われる理由の一つです。",
    weakPoint:
      "人の意見を聞いて大事にしすぎてしまう面があり、大きな集団のリーダーにはあまり向いていません。人に向き合いすぎて疲れてしまうこともしばしばで、愚痴っぽくなったら疲れているサイン。マルチタスクやクリエイティブな仕事はそれほど得意ではありません。",
    tactic:
      "上級の「経営者のリーダーシップ」講座はいかがでしょう？目標とその管理方法を身につけることで、温かさと厳しさを持ち合わせたリーダーへと進化することができます。",
    tacticThumbnail: "book-leadership.png",
    tacticId: "3c4b0002-a4f1-4092-a066-2a9a8b40a156",
  },
];
